import axios from 'axios';
import qs from 'qs';
import Utils from './utils';
import {Indicator, Toast} from 'mint-ui';

const DefaultParam = { repeatable: false };

let ajax = {
  //正式
   PREFIX: '/',
  //测试
  // PREFIX: '/api/v3/applet/',
  Author: Utils.getAuthor() || '',
  requestingApi: new Set(),
  extractUrl: function (url) {
    return url ? url.split('?')[0] : '';
  },
  isRequesting: function (url) {
    let api = this.extractUrl(url);
    return this.requestingApi.has(api);
  },
  addRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.add(api);
  },
  deleteRequest: function (url) {
    let api = this.extractUrl(url);
    this.requestingApi.delete(api);
  },
  get: function (url, param, extendParam) {
    let params = {
      url,
      method: 'GET'
    };
    if (param) {
      params.params = param;
    }
    return this.ajax(params, extendParam);
  },
  post: function (url, param, extendParam) {
    var params = {
      url,
      method: 'POST'
    };
    if (param) params.data = qs.stringify(param);
    return this.ajax(params, extendParam);
  },
  postJson: function (url, paramJson, extendParam) {
    return this.ajax({
      url,
      method: 'POST',
      data: paramJson
    }, extendParam);
  },
  patchJson: function (url, paramJson, dataType, extendParam) {
    return this.ajax({
      url,
      method: 'PATCH',
      data: paramJson
    }, extendParam);
  },
  delete: function (url, extendParam) {
    return this.ajax({
      url: url,
      method: 'DELETE'
    }, extendParam);
  },
  ajax: function (param, extendParam) {

    let params = Utils.extend({}, DefaultParam, param, extendParam || {});
    params.crossDomain = params.url.indexOf('http') === 0;

    let url = params.url;
    if (!params.crossDomain) {
      url = params.url = this.PREFIX + params.url;
    }

    if (params.method != 'GET') {
      if (params.repeatable === false) {
        this.addRequest(url);
      }
    }
    let header = {
      Authorization: Utils.getLocal('Authorization') || '',
      token:Utils.getLocal('token') || ''
    };
    let defaultParam = {
      headers: header,
      responseType: 'json',
      validateStatus: function () {
        return true;
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { allowDots: true });
      }
    };
    if (params.crossDomain) {
      defaultParam.headers = {};
    }
    let that = this;
    params = Utils.extend({}, defaultParam, params);
    return new Promise((resolve, reject) => {
      return axios.request(params).then((response) => {
        that.deleteRequest(params.url);
        let data = response.data;
        let status = response.status;
        // 如果后端统一封装返回，即所有的请求都是10000, 错误码由返回结果提供，则使用以下代码获取状态
        if (status == 200) {
          status = data.status;
        }
        if(data.code === 10003){
          window.top.location = '/phone';
        }
        if(data.code === 10001){
          Utils.removeLocal("Authorization")
          window.top.location = '/';
        }
        data.ok = status == 10000;
        if(data.code === 10000){
          resolve(data.result);
        }else {
          reject();
          Indicator.close()
          Toast({message:data.msg,duration: 1200})
        }

      }).catch((e) => {
        Indicator.close()
        reject(e);
      });
    });
  }
};
export default ajax;
